module.exports = __webpack_public_path__ + "assets/2cd26aee191307d368a8ab9a3370c972.svg";